export function isPromise(value) {
  return value !== null && typeof value === 'object' && 'then' in value;
}